import { render, staticRenderFns } from "./FeedbackForm.vue?vue&type=template&id=61174a62&scoped=true&"
import script from "./FeedbackForm.vue?vue&type=script&setup=true&lang=js&"
export * from "./FeedbackForm.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./FeedbackForm.vue?vue&type=style&index=0&id=61174a62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61174a62",
  null
  
)

export default component.exports